import React, { useState } from 'react';
import { Mail, Loader2, CheckCircle, ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { authAPI } from '../lib/api';

export default function EmailVerificationPending() {
  const { user, logout } = useAuth();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const resendVerification = async () => {
    setSending(true);
    setError('');
    setSent(false);

    try {
      await authAPI.resendVerification(user?.email);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to resend verification email');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0d1117] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-[#16213e] rounded-xl border border-[#00E599]/20 p-8 text-center">
        <div className="w-16 h-16 bg-[#7C3AED]/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <Mail className="w-8 h-8 text-[#7C3AED]" />
        </div>
        
        <h1 className="text-2xl font-bold text-white mb-2">Verify Your Email</h1>
        <p className="text-gray-400 mb-6">
          We sent a verification link to<br />
          <span className="text-[#00E599] font-medium">{user?.email}</span>
        </p>

        <div className="bg-[#0d1117] rounded-lg p-4 mb-6 text-left">
          <h3 className="text-white font-medium mb-2">Next steps:</h3>
          <ol className="text-gray-400 text-sm space-y-2">
            <li>1. Check your email inbox (and spam folder)</li>
            <li>2. Click the verification link in the email</li>
            <li>3. Return here to access your dashboard</li>
          </ol>
        </div>

        {sent && (
          <div className="flex items-center justify-center gap-2 text-[#00E599] mb-4">
            <CheckCircle className="w-5 h-5" />
            <span>Verification email sent!</span>
          </div>
        )}

        {error && (
          <div className="text-red-400 text-sm mb-4">{error}</div>
        )}

        <button
          onClick={resendVerification}
          disabled={sending}
          className="w-full px-6 py-3 bg-[#7C3AED] text-white font-semibold rounded-lg hover:bg-[#7C3AED]/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {sending ? (
            <>
              <Loader2 className="w-5 h-5 animate-spin" />
              Sending...
            </>
          ) : (
            'Resend Verification Email'
          )}
        </button>

        <button
          onClick={logout}
          className="mt-4 text-gray-400 hover:text-white transition-colors flex items-center justify-center gap-2 mx-auto"
        >
          <ArrowLeft className="w-4 h-4" />
          Sign out and try different email
        </button>
      </div>
    </div>
  );
}
